import styled from 'styled-components';

import ActionButton from 'components/action-button';
import ContentCopy from 'components/icons/content-copy';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

export const InvitationCodeNumberContainer = styled.div`
  background-color: #fffbf4;
  border-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${primitive.$spacing4};
`;

export const InvitationCodeNumberText = styled.p`
  color: ${primitive.bk.$bbqBrown};
  font-size: 1.375rem;
  font-weight: bold;

  margin: 0;
  text-align: center;
  flex: 1;
`;

export const InvitationCodeNumberCopyIcon = styled(ContentCopy)`
  width: 1.5rem;
  height: 1.5rem;

  cursor: pointer;
`;

export const InformationCard = styled.div`
  background-color: ${primitive.$whiteOpacity30};
  padding: ${primitive.$spacing4};
  border-radius: 8px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: ${primitive.$spacing7};
`;

export const InformationCardImageWrapper = styled.div<{ $bgColor?: string | null }>`
  background-color: ${props => (props.$bgColor ? props.$bgColor : 'transparent')};

  padding: ${primitive.$spacing2};

  min-width: 4rem;
  height: 4rem;
  border-radius: 8px;
`;

export const InformationCardImage = styled(Picture)``;

export const InformationCardTextsContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: ${primitive.$spacing4};
`;

export const InformationCardTitle = styled.h2`
  color: ${primitive.bk.$bbqBrown};
  font-size: var(--font-copyTwo);
  margin: 0;
  margin-bottom: ${primitive.$spacing1};

  font-weight: 700;
`;

export const CardDescription = styled(SanityBlockRenderer)`
  color: ${primitive.bk.$bbqBrown};
  font-size: 0.75rem;
`;

export const ShareMyCodeButton = styled(ActionButton)`
  background-color: ${Styles.color.primary};
  font-size: var(--font-copyTwo);
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  margin-top: ${primitive.$spacing4};

  &:hover {
    background-color: ${Styles.color.primaryHover};
  }

  width: 100%;
`;

export const TermsAndConditions = styled(SanityBlockRenderer)`
  color: ${primitive.bk.$bbqBrown};
  font-size: 0.75rem;
  text-align: center;

  margin-top: ${primitive.$spacing4};
`;
